/** Álbum do dia — grade de miniaturas; tocar abre a foto. */
import { Link, useParams } from 'react-router-dom';

import { useDiasDaViagem } from '../../trip/dias';
import { ResumoNoAlbum } from '../resumo/ResumoNoAlbum';
import { useTrip } from '../../trip/TripContext';
import { Icon } from '../../ui/icons';
import { EmptyState, ErrorState, ScreenHeader, Skeleton } from '../../ui/primitives';
import { ddmm, plural, useAtualizarAoEnviar, useConfigMedia, useFotosDoDia } from './comum';

export function AlbumScreen() {
  const { dia = '' } = useParams();
  const { tripId } = useTrip();
  const dias = useDiasDaViagem(tripId);
  const config = useConfigMedia();
  const oDia = dias.days?.find((d) => d.date === dia) ?? null;
  const fotos = useFotosDoDia(tripId, oDia?.id ?? null);
  useAtualizarAoEnviar(tripId);

  const autores = [...new Set((fotos.data?.items ?? []).map((f) => f.uploader.name))];

  return (
    <section className="screen mem">
      <ScreenHeader
        eyebrow={<span className="mem__data">{ddmm(dia)}{oDia?.title ? ` · ${oDia.title.toUpperCase()}` : ''}</span>}
        title={fotos.isSuccess ? plural(fotos.data.items.length, 'foto', 'fotos') : 'Álbum'}
        trailing={config.data?.media && (
          <Link to={`/memorias/enviar?dia=${dia}`} className="nv-btn nv-btn--chip" aria-label="Enviar fotos deste dia">
            <Icon name="criar" size={16} />
            Enviar
          </Link>
        )}
      />

      <Link to={`/roteiro/${dia}`} className="mem__linha-roteiro">
        <Icon name="roteiro" size={16} />
        Ver o roteiro deste dia
        <Icon name="avancar" size={14} />
      </Link>

      <ResumoNoAlbum dayId={oDia?.id ?? null} />

      {(dias.carregando || fotos.isLoading) && <Skeleton height={120} count={2} />}
      {fotos.isError && <ErrorState title="Não foi possível carregar" description="Verifique a conexão." onRetry={() => void fotos.refetch()} />}
      {dias.days && !oDia && <EmptyState icon={<Icon name="aviso" size={28} />} title="Dia fora da viagem" description="Este dia não faz parte do período da viagem." />}
      {fotos.isSuccess && fotos.data.items.length === 0 && (
        <EmptyState ilustracao="memorias" title="Nenhuma foto neste dia" description="Quem enviar fotos deste dia vê aqui." />
      )}
      {fotos.isSuccess && fotos.data.items.length > 0 && (
        <>
          <div className="mem__grade">
            {fotos.data.items.map((f) => (
              <Link key={f.id} to={`/memorias/${dia}/${f.id}`} className="mem__tile" aria-label={`Foto de ${f.uploader.name}`}>
                <img src={f.thumbUrl} alt="" loading="lazy" />
              </Link>
            ))}
          </div>
          {autores.length > 0 && <p className="auth-note">Fotos de {autores.join(', ')}.</p>}
        </>
      )}
    </section>
  );
}
